import { tivoAppsApi } from "containers/Request/SRPC/apiClient";

import { TEXTS, VCS_SNAPSHOT_SCHEDULE } from "../constants";
import { getScheduleWindow } from "../utils";
import { ScheduleTime } from "./ScheduleTime";
import styles from "./SnapshotSchedule.scss";

export function SnapshotSchedule({ now }: { now: Date }) {
  const { data } = tivoAppsApi.getSnapshotStatus.useQuery();
  const snapshotCreatedAt = data?.results?.created_at
    ? new Date(data.results.created_at)
    : undefined;
  const { nextPull: nextSnapshot } = getScheduleWindow(
    now,
    VCS_SNAPSHOT_SCHEDULE
  );

  return (
    <div className={styles.container}>
      <div className={styles.item}>
        <span className={styles.label}>
          {TEXTS.SNAPSHOT_SCHEDULE.CREATED_AT}
        </span>
        {snapshotCreatedAt ? (
          <ScheduleTime date={snapshotCreatedAt} />
        ) : (
          <span className={styles.pending}>
            {TEXTS.SNAPSHOT_SCHEDULE.PENDING}
          </span>
        )}
      </div>
      <div className={styles.item}>
        <span className={styles.label}>
          {TEXTS.SNAPSHOT_SCHEDULE.NEXT_SNAPSHOT}
        </span>
        {nextSnapshot && <ScheduleTime date={nextSnapshot} now={now} />}
      </div>
    </div>
  );
}
